import { render, staticRenderFns } from "./StaticLayout.vue?vue&type=template&id=0b13edd4&scoped=true&"
import script from "./StaticLayout.vue?vue&type=script&lang=js&"
export * from "./StaticLayout.vue?vue&type=script&lang=js&"
import style0 from "./StaticLayout.vue?vue&type=style&index=0&id=0b13edd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13edd4",
  null
  
)

export default component.exports